import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, computed, effect, inject, model, signal, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppstateService } from 'src/app/services/appstate.service';
import { DataService } from 'src/app/services/data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { IFreigabeDetails } from 'src/app/types/IFreigabeDetails';
import { IFreigabeViewModel } from 'src/app/types/viewmodels/freigabe.viewmodel';
import { ValueChangedEvent } from 'devextreme/ui/file_uploader';
import { DxFileUploaderComponent } from 'devextreme-angular';

@Component({
  selector: 'app-budget-freigabe-dialog',
  // standalone: true,
  // imports: [],
  templateUrl: './budget-freigabe-dialog.component.html',
  styleUrl: './budget-freigabe-dialog.component.css'
})

export class BudgetFreigabeDialogComponent {

  @ViewChild('fileUploader')
  fileUploader!: DxFileUploaderComponent;

  readonly dialogRef = inject(MatDialogRef<BudgetFreigabeDialogComponent>);
  public antrag = computed(() => this.dataFreigabe()?.budgetantrag!);
  public dataFreigabe = computed<IFreigabeViewModel | null>(() => this.dataService.budgetantragFreigabe());
  public dataFreigabeAnmerkung = model<string>("");
  public dataFreigabePlausibilitaet = computed(() => this.dataFreigabe()?.plausibilitaetText!);
  public IsErsterBearbeiter = computed(() => this.dataFreigabe()?.bearbeiterVorheriger === this.dataFreigabe()?.bearbeiterAktuell);
  public dataFile = signal<File>(new File([], ''));
  public dataFileURL = computed(() => this.dataFile().size ? URL.createObjectURL(this.dataFile()!) : "blob:");
  private dataFileInitializing = false;

  constructor(private dataService: DataService,
              private dialogService: DialogService,
              private appStateService: AppstateService,) {

    effect(() => {
      if (this.dataFreigabe()?.fileNameAnhang && this.dataFreigabe()?.fileNameAnhang != '') {
        // load file 
        this.dataService.readFreigabeAnhang(this.appStateService.budgetantragId(), this.dataFreigabe()!.bearbeiterAktuell!).subscribe({
          next: (data: any) => {
            if (data) {
              this.dataFile.set(data);
              var file = new File([data], this.dataFreigabe()!.fileNameAnhang!, { type: data.type });
              this.dataFileInitializing = true;
              this.fileUploader.instance.option("value", [file]);             
              this.dataFileInitializing = false;
            }
         }  
        });
      }
    }, { allowSignalWrites: true });  
  };

  onFileUploadValueChanged(e: ValueChangedEvent): void {
    if (this.dataFileInitializing == true) return; // during initialization, do nothing)
    
    const reader: FileReader = new FileReader();
    reader.onload = (args) => {
      if (typeof args.target?.result === 'string') {
        var resultBase64 = args.target.result as string;
        var resultFile = this.convertBase64ToFile(resultBase64, e.value![0].name);
        this.dataFile.set(resultFile);
        // POST file to backend
        const formData = new FormData();
        var filename = this.fileUploader.value[0].name;
        formData.append("file", this.dataFile()!, filename);
        this.dataService.updateFreigabeAnhang(this.appStateService.budgetantragId()!, this.dataFreigabe()!.bearbeiterAktuell!, formData).subscribe({
          next: (data: any) => {
            // update freigabe data
            this.dataFreigabe()!.fileNameAnhang = filename;
            this.dialogService.showMessageSheet('Der Anhang wurde hochgeladen und gespeichert');
          },
          error: (err: HttpErrorResponse) => {
            this.dataFile.set(new File([], ''));
            this.fileUploader.instance.option("value", []);
            throw Error();
          }
        });
      }
    };

    if (e.value && e.value.length > 0) {
      // convert to base64 string
      reader.readAsDataURL(e.value![0]);
    }
  }

  onFileUploadDeleteButtonClick(): void {
    if (this.dataFile().size != 0) {
      URL.revokeObjectURL(this.dataFileURL()!);
    }
    // DELETE file from backend
    this.dataService.deleteFreigabeAnhang(this.appStateService.budgetantragId()!, this.dataFreigabe()!.bearbeiterAktuell!).subscribe({
      next: (data: any) => {
        // update freigabe data
        this.dataFreigabe()!.fileNameAnhang = undefined;
        this.fileUploader.instance.option("value", []);
        this.dataFile.set(new File([], ''));   
        this.dialogService.showMessageSheet('Der Anhang wurde gelöscht');
      },
      error: (err: HttpErrorResponse) => {
        throw Error();
      }
    });
  }

  onFileUploadShowButtonClick(): void {
    if (this.dataFile().size != 0) {
      window.open(this.dataFileURL(), '_blank');
    }
  }

  private convertBase64ToFile(base64Image: string, fileName: string) {
    // Split into two parts
    const parts = base64Image.split(';base64,');
    // Hold the content type
    const imageType = parts[0].split(':')[1];
    // Decode Base64 string
    const decodedData = window.atob(parts[1]);
    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);
    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // Return BLOB image after conversion
    var blob = new Blob([uInt8Array], { type: imageType });

    return new File([blob], fileName, { type: imageType });
  }

  button_reject_clicked() {
    if (this.dataFreigabe()?.bearbeiterVorheriger == "PST" && !this.dataFreigabe()?.budgetantrag?.pstID)
			  this.dialogService.showDialog('Der Budgetantrag hat keinen zugeordneten PST. Bitte benachrichtigen Sie die Administratoren, damit diese über die PKDB dem Projekt einen PST zuweisen.','Ablehnung', "", 320).subscribe();
	else this.dialogService.showDialog(`Möchten Sie die Freigabe ablehnen und den Budgetantrag an die Bearbeitungsstufe ${this.dataFreigabe()?.bearbeiterVorheriger} zurück senden?`, 'Ablehnung', undefined, 220).subscribe(result => {
      if (result) {
        var details: IFreigabeDetails = { anmerkung: this.dataFreigabeAnmerkung(), ursachen: "" };
        this.dialogRef.close();
        this.dataService.updateFreigabeReject(this.appStateService.budgetantragId()!, details).subscribe({
          next: (dataFreigabe: HttpResponse<IFreigabeViewModel>) => {
            if (dataFreigabe?.body) {
              this.dataService.budgetantragFreigabe.set(dataFreigabe.body);
            }
            this.dialogService.showInfoDialog(`Die Freigabe wurde abgelehnt ${dataFreigabe.body!.mailSuccess ? `und die aktuelle Zuständigkeit ${dataFreigabe?.body?.bearbeiterAktuell} informiert.` : `aber die Benachrichtigung per Mail ist fehlgeschlagen. Grund: ${dataFreigabe.body!.mailRespond}`}`,"Ablehnung",400);
          },
          error: (err: HttpErrorResponse) => { }
        });
      }
    })
  }

  button_apply_clicked() {
    var question= `Möchten Sie den Budgetantrag an die nächste Bearbeitungsstufe ${this.dataFreigabe()?.bearbeiterNaechster} weiterleiten?`;
    var isFinalFreigabe = this.dataFreigabe()?.bearbeiterNaechster === "Freigabe";
    if (isFinalFreigabe)
      question = `Möchten Sie den Budgetantrag jetzt final freigeben? Er ist danach über das Archiv einsehbar und als Budgetplan in der PKDB verfügbar.`;
    this.dialogService.showDialog(question, 'Genehmigung', undefined, 220).subscribe(result => {
      if (result) {
        var details: IFreigabeDetails = { anmerkung: this.dataFreigabeAnmerkung(), ursachen: "" };
        this.dialogRef.close();
        this.dataService.updateFreigabeApply(this.appStateService.budgetantragId()!, details).subscribe({
          next: (dataFreigabe: HttpResponse<IFreigabeViewModel>) => {
            if (dataFreigabe?.body) {
              this.dataService.budgetantragFreigabe.set(dataFreigabe.body);
            }
            this.dataService.refreshBudgetantragDetails();
			var hinweis : string;
            if (isFinalFreigabe)
				hinweis = `Der Budgetantrag wurde erfolgreich freigegeben und ist als aktueller Budgetplan in der PKDB verfügbar. ${dataFreigabe.body!.mailSuccess ? `Der PST und PM werden per Mail über die finale Freigabe informiert.` : `Die Benachrichtigung per Mail ist fehlgeschlagen. Grund: ${dataFreigabe.body!.mailRespond}`}`;
        	else
                hinweis = `Die Freigabe wurde genehmigt ${dataFreigabe.body!.mailSuccess ? `und die neue Zuständigkeit ${dataFreigabe?.body?.bearbeiterAktuell} informiert.` : `aber die Benachrichtigung per Mail ist fehlgeschlagen. Grund: ${dataFreigabe.body!.mailRespond}`}`;
            this.dialogService.showInfoDialog(hinweis,"Freigabe",400);
          },
          error: (err: HttpErrorResponse) => { }
        });
      }
    })
  }

  CloseButtonClick(): void {
    this.dialogRef.close();
  }

  button_showBericht_clicked() {
    this.dataService.generateReport(this.appStateService.budgetantragId()!).subscribe(result => {
      var newWindow = window.open(result.url);
      newWindow?.document.close();
      newWindow?.focus();
    });
  }
}

